<template>
   <v-form
    ref="form"
    v-model="valid"
    lazy-validation>
    <v-container>
      <v-alert type="warning" v-model="havealert" dismissible close-text="Close Alert">
          {{havemssgalert}}
      </v-alert>
      <v-row no-gutters justify="center">
        <v-col xl="2" lg="2" xs="10" sm="6" md="6">
            <br>
            <v-text-field
              label="Email"
              outlined
              v-model="email"
              :rules="emailRules"
            ></v-text-field>
            <br>
            <v-text-field
              outlined
              label="Password"
              type="password"
              v-model="password"
              :rules="[rules.required]"
            ></v-text-field>
            <br>
            <div class="danger-alert" v-html="error" />
            <br>
            <v-row align="center">
              <v-col class="text-center" cols="12" sm="12">
              <v-btn
                large
                block
                :disabled="!valid"
                @click="login">
                Login
              </v-btn>
              <v-progress-circular v-if="this.saving"
                indeterminate
                color="green"
              ></v-progress-circular>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="text-center" cols="12" sm="12">

              </v-col>

            </v-row>
        </v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import UserService from '@/services/UserService'

export default {
  name: 'login',
  data () {
    return {
      saving: false,
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      valid: true,
      lazy: false,
      rules: {
        required: value => !!value || '*'
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      email: '',
      password: '',
      error: null,
      locError: 0,
      currentYear: 0,
      userHaveCompany: [],
      companyBY: [],
      defaultCompanyId: 0,
      mainQuery: {
        email: ''
      },
      mainQuery2: {
      },
      account1s: [],
      account2s: [],
      account3s: [],
      account4s: [],
      itemsLoc: [],
      groupsLoc: [],
      employes: [],
      havealert: false,
      havemssgalert: '',
    }
  },
  mounted () {
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        // this.snackbar = true
        this.login()
      }
    },
    async login () {

      try {
        this.locError = 0
        const response = await UserService.login({
          email: this.email,
          password: this.password
        })

        if (response.data.user.beton === false) {
          this.locError = 1
          this.error = 'Greska!! Korisnik ne postoji ili nema dodijeljena prava!'

          this.$router.push({
            path: '/'
          })
        }
        if (this.locError === 0) {
          this.$store.dispatch('setToken', response.data.token)
          this.$store.dispatch('setUser', response.data.user)
          if (response.data.user.jezik) {
            this.$store.dispatch('setLanguage', response.data.user.jezik)
          }
          this.saving = false
          this.$router.push({
            name: 'Home'
          })
        }

      } catch (error) {
        this.saving = false
        if (error.response && error.response.status === 403) {
          this.error = 'Wrong email or password.'
        } else {
          this.error = 'Login error. Please try again or contact the administrator.'
        }
      }
    },
    register () {
      this.$router.push({
        name: 'userregister'
      })
    },
    async writeDatePartners() {
      await this.$store.dispatch('setDatePartners', new Date())
    }
  },
  computed: {

  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
